import { Switch } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const PaymentPreferences = () => {
    const navigate = useNavigate();
    const [tabbyEnabled, setTabbyEnabled] = useState(false);
    const [tamaraEnabled, setTamaraEnabled] = useState(false);

    return (
        <>
            <div className="main_title">
                <h1>Payment Preferences</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Payment Preferences
                </p>
            </div>

            <div className="cards payment_preference">
                <div className="form">
                    <div className="gap_p">

                        <div className="control_group w_100">
                            <label>Activate Tabby Payments (7% fee applies)</label>
                            <div className="toggle_wrap">
                                <Switch
                                    checked={tabbyEnabled}
                                    onChange={(e) => setTabbyEnabled(e.target.checked)}
                                />
                            </div>
                        </div>

                        <div className="control_group w_100">
                            <label>Activate Tamara Payments (7% fee applies)</label>
                            <div className="toggle_wrap">
                                <Switch
                                    checked={tamaraEnabled}
                                    onChange={(e) => setTamaraEnabled(e.target.checked)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {/* Toggle Options */}

                {/* Mandatory Disclosure */}
                <div className="info_note">
                    BNPL providers (Tabby/Tamara) deduct a 7% fee from each BNPL order.
                    By enabling this service, you agree to the applicable fee structure.
                    <br />
                    <strong>(This message can be customized from the Admin Panel)</strong>
                </div>

            </div>


        </>
    );
}
export default PaymentPreferences